/**
 *  @fileOverview Modal module, initalises unit description modal instances, uses https://micromodal.now.sh/
 *
 *  @author       Chris Hill
 *
 */

function UnitcodeModule (axios, Micromodal) {
  /**
   * @description Initialises modal instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Get all unit links
     */
    var ulinks = document.querySelectorAll('a[data-unit]')

    /**
     * Only rubn if unit links are present on page
     */
    if (ulinks.length > 0) {
      /**
       * Loop through and add click events
       */
      ulinks.forEach((link, index) => {
        /**
         * Append icon to link text
         */
        let ltext = link.innerHTML
        ltext += '<span class="table__icon"><i title="Open modal" class="fas fa-info-circle"></i></span>'
        link.innerHTML = ltext

        link.addEventListener('click', function (e) {
          e.preventDefault()

          let code = link.dataset.unit
          let url = 'https://www.ecu.edu.au/handbook/lookups/unit-modal?id=' + code

          /**
           * Retrieve unit info from Funnelback
           */
          axios.get(url)
            .then(response => {
              /**
               * Create modal object
               */
              let modal = document.createElement('div')
              modal.id = 'unitPopup'
              modal.className = 'modal'
              modal.setAttribute('aria-modal', true)
              modal.setAttribute('aria-hidden', true)

              /**
               * Append modal to body
               */
              document.querySelector('body').appendChild(modal)

              /**
               * Check if object exists if not display not available
               */
              if (typeof (response.data.title) === 'undefined') {
                modal.innerHTML = `
                  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                    <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__title">
                      <header class="modal__header">
                        <h3 id="modal__title" class="base__heading base__heading--medium">${code}</h3>
                      </header>
                      <main class="modal__body">
                        <p>Unit description not available</p>
                      </main>
                      <button class="modal__close" aria-label="Close modal">
                        <i title="close modal" class="fas fa-times fa-2x"></i>
                      </button>
                    </div>
                  </div>`
              } else {
                modal.innerHTML = `
                  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                    <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__title">
                      <header class="modal__header">
                        <h3 class="base__heading base__heading--medium">${code}</h3>
                        <h4 id="modal__title" class="base__heading base__heading--small">${response.data.title}</h4>
                      </header>
                      <main class="modal__body">
                        <p>${response.data.desc}</p>
                        <a href="${response.data.timetable}" class="button button--light">View Semester Timetable</a>
                        <br>
                        <a href="${response.data.handbook}" class="button button--textOnly">View Handbook</a>
                      </main>
                      <button class="modal__close" aria-label="Close modal">
                        <i title="close modal" class="fas fa-times fa-2x"></i>
                      </button>
                    </div>
                  </div>`
              }

              /**
               * Initialise Micromodal, remove modal div on close
               */
              Micromodal.show('unitPopup', {
                // onShow: modal => console.info(`${modal.id} is shown`), // [1]
                onClose: modal => modal.parentNode.removeChild(modal)
              })

              let closebtn = document.querySelector('.modal__close')

              closebtn.addEventListener('click', function (e) {
                e.preventDefault()

                Micromodal.close('unitPopup')
                closebtn.removeEventListener('click', function (e) {})
              })
            })
            .catch(e => {
              console.log(e)
            })
        })
      })
    }
  }
}

module.exports = UnitcodeModule
